import { gql, useMutation } from '@apollo/client';

import { PARN_DETAILS_QUERY } from '../queries/ParnDetails';
import {
  FirstContactAttemptedForParn,
  FirstContactAttemptedForParnVariables,
} from './__generated__/FirstContactAttemptedForParn';

export const FIRST_CONTACT_ATTEMPTED_FOR_PARN = gql`
  mutation FirstContactAttemptedForParn($parnId: String!, $firstContactAttemptedAt: DateTime!) {
    odProtosListingsServicesPartneragentreferralnetwork {
      firstContactAttemptedForPARN(
        input: { parnId: $parnId, firstContactAttemptedAt: $firstContactAttemptedAt }
      ) {
        _empty
      }
    }
  }
`;

/**
 * Previous state: AGENT_ASSIGNED
 * transitions to state: FIRST_CONTACT_MADE_FOR_PARN
 * Records when an agent first attempted to contact the seller
 */
export const useFirstContactAttemptedForParn = () => {
  const [firstContactAttemptedForParnMutation, { data, error, loading }] = useMutation<
    FirstContactAttemptedForParn,
    FirstContactAttemptedForParnVariables
  >(FIRST_CONTACT_ATTEMPTED_FOR_PARN, {
    fetchPolicy: 'no-cache',
    context: {
      clientName: 'athena',
    },
    refetchQueries: [PARN_DETAILS_QUERY],
  });

  const setFirstContactAttemptedForParn = (parnId: string, firstContactAttemptedAt: string) =>
    firstContactAttemptedForParnMutation({
      variables: { parnId, firstContactAttemptedAt },
    });
  return { setFirstContactAttemptedForParn, data, loading, error };
};
